<template>
    <div class="comment-item-bg" @click.stop="$emit('item-click')">
        <img class="head-img"
            :src="content.comments_img ? content.comments_img : require('@/assets/images/comment/xiugaitouxiang_bg.png')" />
        <div class="nickname-wrap">
            <p class="nickname">{{content.comments_username}}</p>
            <p class="comment-time">{{content.comments_created_at}}</p>
        </div>
        <div class="reply" @click.stop="$emit('item-reply')">
            {{$t('comment.reply')}}
        </div>
        <div v-if="content.comment_content_type == 1">
            <div class="comment-text">
                <template v-for="(detail,index) in parsingEmoji(content.comments_content)">
                    <span v-if="detail.type=='text'" :key="index">{{detail.value}}</span>
                    <img class="emoji-img" v-else-if="detail.type=='image'" :src="face[detail.value]" alt=""
                        :key="index" />
                </template>
            </div>
            <div class="comment-img">
                <img v-for="(img, index) in content.comments_photo" :src="img+'?x-oss-process=image/resize,w_750'"
                    :key="index" @click.stop="$emit('item-preview-images',{images:content.comments_photo,index})"/>
            </div>
        </div>
        <template v-if="content.parent_id != 0">
            <div class="up-pinglun" v-if="content.parent_type==1">
                @{{content.parent_username}}：
                <template v-for="(detail,index) in parsingEmoji(content.parent_content)">
                    <span v-if="detail.type=='text'" :key="index">{{detail.value}}</span>
                    <img class="emoji-img" v-else-if="detail.type=='image'" :src="face[detail.value]" alt=""
                        :key="index" />
                </template>
            </div>
            <div class="up-pinglun" v-else-if="content.parent_type==2">
                @{{content.parent_username}}：[图片]
            </div>
        </template>
    </div>
</template>

<script>
    import FaceHelper from '@/js/comment/Analysisimg.js'
    import face from '@/js/comment/face.js'

    export default {
        props: {
            content: {
                type: Object,
                require: true,
                defalut: {}
            }
        },
        data() {
            return {
                face
            }
        },
        created() {

        },
        methods: {
            parsingEmoji(str) {
                return FaceHelper.create(str).elements
            },
        }

    }
</script>

<style scoped>
    .head-img {
        width: 1.45rem;
        height: 1.45rem;
        vertical-align: top;
        margin-right: 6px;
        border-radius: 50%;
    }

    .nickname-wrap {
        display: inline-block;
        vertical-align: top;
        width: 73.6%;
    }

    .nickname {
        margin: 0;
        font-size: 14px;
        color: #545454;
    }

    .comment-time {
        margin: 0;
        font-size: 12px;
        color: #989898;
    }

    .reply {
        display: inline-block;
        width: 1.7rem;
        height: 0.64rem;
        font-size: 14px;
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
    }

    .comment-text {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        margin-top: 0.42rem;
        line-height: 30px;
        font-size: 14px;
    }

    .comment-img {
        margin-top: 0.42rem;
        margin-bottom: 0.4rem;
    }

    .comment-img img {
        width: 2.13rem;
        height: 2.13rem;
        margin-right: 0.42rem;
    }

    .up-pinglun {
        display: flex;
        flex-direction: row;
        align-items: center;
        background: #f8f8f8;
        font-size: 14px;
        color: #9a9a9a;
        line-height: 0.78rem;
        padding: 0.5rem 0.5rem;
    }

    .emoji-img {
        width: 0.65rem;
        height: 0.65rem;
    }
</style>